export const Util = {
  randomRange: function (min: number, max: number): number {
    return min + Math.random() * (max - min);
  },

  //a modulo function that handles negatives numbers 'correctly'
  modWrap: function (n: number, m: number): number {
    return ((n % m) + m) % m;
  },
};
